import { InjectionToken } from '@angular/core'
import { Actor } from '@monorepo/next-lab'

export interface NextlabActorProvider {
  getActor(): Actor
}

export const NEXTLAB_ACTOR_PROVIDER = new InjectionToken<NextlabActorProvider>('NEXTLAB_ACTOR_PROVIDER')
